import { useState } from 'react';

import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ChevronDown from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-down';
import ChevronUp from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/chevron-up';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useMBDContext } from '../../common/MBD/useMBDContext';

import type {
  DynamicMapStrings,
  MapLocation,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/DynamicMapProps';

import STYLES from './Locations.module.scss';

export type LocationsProps = {
  locations: MapLocation[];
  strings: DynamicMapStrings;
};
const Locations = ({ locations, strings }: LocationsProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const ChevronDownArrow = withRtlSupport(ChevronDown);
  const ChevronUpArrow = withRtlSupport(ChevronUp);
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const clickShowButton = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      {expanded ? (
        <div className={STYLES.Locations__linklist}>
          {locations.map((location, index) => (
            <div
              className={STYLES.Locations__link}
              key={location.url}
              data-testid="location-link"
              data-tracking-element-id={`${rawComponentName}_location_item_${index}`}
              data-tracking-common-params={buildMBDParam(
                `${rawComponentName}_location_item`,
                {
                  location_link_name: location.name,
                },
              )}
            >
              <BpkLink href={location.url} rel="nofollow">
                <BpkText textStyle={TEXT_STYLES.footnote}>
                  {location.name}
                </BpkText>
              </BpkLink>
            </div>
          ))}
        </div>
      ) : null}
      <div className={STYLES.Locations__showMore}>
        <BpkButton
          onClick={() => clickShowButton()}
          data-testid="expand-collapse"
          data-tracking-element-id={`${rawComponentName}_item`}
          data-tracking-common-params={buildMBDParam(
            `${rawComponentName}_item`,
            {
              trigger_component: 'locations',
              action: expanded ? 'expand' : 'collapse',
            },
          )}
          type={BUTTON_TYPES.link}
          implicit
        >
          <BpkText textStyle={TEXT_STYLES.label1}>
            {expanded ? strings.hideAllLocation : strings.showAllLocation}
          </BpkText>
          {expanded ? <ChevronUpArrow /> : <ChevronDownArrow />}
        </BpkButton>
      </div>
    </>
  );
};

export default Locations;
